import React from "react";

const PortfolioBanner = () => {
  return (
    <div className="portfolioBanner">
      <div className="mx-auto max-w-screen-xl">
        <div className="bannerContent">
          <h2>PORTFOLIO</h2>
          <p>
            Lorem ipsum dolor ngồi amet consectetuer lorem ipsum dolor ngồi amet
            consectetuer lorem ipsum dolor ngồi amet consectetuer lorem ipsum
            dolor
          </p>
          <button>Contact us</button>
        </div>
      </div>
    </div>
  );
};

export default PortfolioBanner;
